export async function init() {
    setTabsListener();
}

function setTabsListener() {
    const productsTabInputs = document.querySelectorAll(".products-tab input");

    if (productsTabInputs.length === 0) return;

    // "change" (niet "click"): ook pijltjestoetsen op de radio's wisselen de prijzen.
    productsTabInputs.forEach((tab) => {
        tab.addEventListener("change", () => {
            const pricesField = document.querySelectorAll("[data-price-type]");

            pricesField?.forEach((price) => {
                price.classList.toggle(
                    "hidden",
                    price.dataset.priceType !== tab.value,
                );
            });
        });
    });
}
